import { Block } from '@gitbook/slate';

import { BLOCK_OPENAPI_WEBHOOK, type BlockOpenAPIWebhookData } from '../types';

/**
 * Create an OpenAPI Operation block referencing an OpenAPI specification.
 */
export function createOpenAPIWebhookBlockWithRef(data: BlockOpenAPIWebhookData): Block {
    return Block.createVoid({
        type: BLOCK_OPENAPI_WEBHOOK,
        data,
    });
}
